import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid, TextField } from '@material-ui/core';

import AutoSuggestionSelect from '../AutoSuggestionSelect';
import Progress from '../../containers/ProgressContainer';
import Snackbar from '../../containers/SnackbarContainer';
import FormSubmitButton from '../FormSubmitButton';
import Dropzone from '../Dropzone';
import Table from '../Table';
import ProcessRow from './ProcessRow';

import months from '../../utils/months';

const styles = {
  container: {
    padding: '30px',
  },
};

class AutomaticTab extends PureComponent {
  constructor() {
    super();
    this.state = {
      files: [],
      month: null,
      year: '',
      rows: [
        { id: 'status', numeric: false, disablePadding: true, label: 'Estado' },
        { id: 'name', numeric: false, disablePadding: false, label: 'Proceso' },
        { id: 'status_message', numeric: false, disablePadding: true, label: '' },
        { id: 'date', numeric: false, disablePadding: true, label: '' },
      ],
    };

    this.onDrop = this.onDrop.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleMonthChange = this.handleMonthChange.bind(this);
  }

  componentDidMount() {
    this.props.getProceses(1);
  }

  onDrop(files) {
    this.setState({ files });
  }

  handleChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  handleMonthChange(value) {
    this.setState({ month: value });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { createProcess, showSnackbar } = this.props;
    const { files, year, month } = this.state;

    if (month) {
      const process = new FormData();

      process.append('multiple_upload[file]', files[0]);
      process.append('multiple_upload[month]', month.value);
      process.append('multiple_upload[year]', year);

      createProcess(process);
    } else {
      showSnackbar('Es necesario ingresar el mes.', 'error');
    }
  }

  render() {
    const { month, year } = this.state;
    const { classes, isFetching, proceses, total, pages, history } = this.props;
    const { rows } = this.state;

    return (
      <form onSubmit={this.handleSubmit}>
        <Grid className={classes.container} container alignItems="center" spacing={32}>
          <Grid item xs={6}>
            <AutoSuggestionSelect
              required
              value={month}
              options={months}
              placeholder="Mes"
              label="Mes"
              onChange={this.handleMonthChange}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              required
              value={year}
              type="text"
              label="Año"
              name="year"
              inputProps={{
                maxLength: 4,
                minLength: 4,
              }}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <div className="dropzone">
              <Dropzone onDrop={this.onDrop} />
            </div>
          </Grid>
          <FormSubmitButton />
          <Grid item xs={12}>
            <Table
              isFetching={isFetching}
              rows={rows}
              data={proceses}
              total={total}
              pages={pages}
              history={history}
              paginated
              page={0}
              renderRows={({ item }) =>
                (<ProcessRow
                  key={item.id}
                  process={item}
                />)
              }
            />
          </Grid>
          { isFetching && <Progress /> }
          <Snackbar />
        </Grid>
      </form>
    );
  }
}

export default withStyles(styles)(AutomaticTab);

AutomaticTab.propTypes = {
  classes: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired,
  proceses: PropTypes.array.isRequired,
  getProceses: PropTypes.func.isRequired,
  createProcess: PropTypes.func.isRequired,
  showSnackbar: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  history: PropTypes.object.isRequired,
};

AutomaticTab.defaultProps = {
  isFetching: false,
};



// WEBPACK FOOTER //
// ./src/components/Paychecks/AutomaticTab.js